import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";

const LegalPage: React.FC = () => {
  return (
    <>
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <header className="flex justify-between items-center mb-8">
            <Logo size="medium" />
            <Link
              to="/"
              className="text-orange-500 hover:text-orange-600 font-medium"
            >
              Volver a la página de inicio
            </Link>
          </header>

          <div className="bg-white rounded-lg shadow-md p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8">
              Test Latino™ – Documentos Legales
            </h1>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                POLÍTICA DE PRIVACIDAD
              </h2>
              <div className="text-sm text-gray-600 mb-4">
                <p>Fecha de Vigencia: 13 de mayo de 2025</p>
                <p>Última Actualización: 13 de mayo de 2025</p>
              </div>

              <div className="prose max-w-none">
                <p className="mb-4">
                  YOJ Inc. respeta su privacidad. Esta Política de Privacidad explica cómo recopilamos, utilizamos y compartimos su información personal cuando utiliza la aplicación y el sitio web del Test Latino™.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  1. Información que Recopilamos
                </h3>
                <p className="mb-4">
                  Información Personal: como su nombre, dirección de correo electrónico, información demográfica y respuestas a la evaluación.
                  <br />
                  Información Técnica: como dirección IP, tipo de navegador, información del dispositivo y datos de uso a través de cookies y análisis.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  2. Cómo Utilizamos su Información
                </h3>
                <ul className="list-disc pl-5 mb-4">
                  <li>Proporcionar, personalizar y mejorar la experiencia de la evaluación</li>
                  <li>Enviarle correos electrónicos sobre nuevos programas, ofertas o actualizaciones</li>
                  <li>Contactarlo con invitaciones a eventos o contenido exclusivo</li>
                  <li>Monitorear y analizar el uso para rendimiento y seguridad</li>
                </ul>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  3. Marketing y Comunicación
                </h3>
                <p className="mb-4">Al proporcionar su información y aceptar esta política, usted consiente recibir correos electrónicos promocionales de YOJ Inc. Puede cancelar su suscripción en cualquier momento haciendo clic en "Cancelar suscripción" en cualquier correo electrónico o contactándonos en results@latinocareertest.com.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  4. Compartir su Información
                </h3>
                <p className="mb-4">
                  Podemos compartir o alquilar su información personal a socios de confianza, afiliados comerciales o proveedores de servicios para fines de marketing, promocionales o relacionados con programas. Estos socios están obligados a utilizar sus datos de acuerdo con nuestras prácticas de privacidad y las leyes aplicables.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  5. Seguridad de Datos
                </h3>
                <p className="mb-4">Tomamos medidas razonables para proteger sus datos. Sin embargo, ninguna transmisión por internet es 100% segura.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  6. Sus Derechos
                </h3>
                <p className="mb-4">Puede solicitar acceder, actualizar o eliminar sus datos personales en cualquier momento enviando un correo electrónico a results@latinocareertest.com.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  7. Privacidad de Menores
                </h3>
                <p className="mb-4">
                 Nuestra evaluación no está destinada a usuarios menores de 13 años. No recopilamos conscientemente datos de menores.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  8. Actualizaciones a Esta Política
                </h3>
                <p className="mb-4">Podemos actualizar esta Política de Privacidad de vez en cuando. Notificaremos a los usuarios actualizando la fecha de "Última Actualización" arriba.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  9. Contáctenos
                </h3>
                <p className="mb-4">
                  Para cualquier pregunta sobre esta Política de Privacidad, por favor contáctenos en results@latinocareertest.com.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                TÉRMINOS DE USO
              </h2>
              <div className="text-sm text-gray-600 mb-4">
                <p>Fecha de Vigencia: 13 de mayo de 2025</p>
                <p>Última Actualización: 13 de mayo de 2025</p>
              </div>

              <div className="prose max-w-none">
                <p className="mb-4">Bienvenido al Test Latino™, propiedad y operado por YOJ Inc. Estos Términos de Uso rigen su acceso y uso de nuestro sitio web, evaluación y servicios asociados.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  1. Aceptación de Términos
                </h3>
                <p className="mb-4">Al utilizar este sitio o aplicación, usted acepta estos Términos de Uso y nuestra Política de Privacidad. Si no está de acuerdo, no utilice el servicio.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  2. Uso de la Evaluación
                </h3>
                <p className="mb-4">Puede utilizar la evaluación únicamente para fines personales y no comerciales. Usted acepta no reproducir, revender o distribuir la evaluación, su contenido o resultados sin permiso escrito de YOJ Inc.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  3. Propiedad Intelectual
                </h3>
                <p className="mb-4">Todo el contenido, incluyendo la evaluación, preguntas, arquetipos, diseño, marca y marcas registradas (por ejemplo, Test Latino™), son propiedad de YOJ Inc. y están protegidos por las leyes de derechos de autor y marcas registradas de Estados Unidos.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  4. Sin Garantías
                </h3>
                <p className="mb-4">Esta evaluación es únicamente para fines informativos y de entretenimiento. No constituye asesoramiento profesional, evaluación psicológica o consejo profesional.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  5. Limitación de Responsabilidad
                </h3>
                <p className="mb-4">YOJ Inc. no es responsable por ningún daño que surja del uso o la incapacidad de usar el Test Latino™, incluyendo cualquier decisión tomada basada en los resultados de la evaluación.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  6. Conducta del Usuario
                </h3>
                <p className="mb-4">Usted acepta no hacer mal uso de la plataforma, subir contenido dañino o violar cualquier ley mientras utiliza la evaluación.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  7. Terminación
                </h3>
                <p className="mb-4">Nos reservamos el derecho de restringir o terminar su acceso en cualquier momento por violación de estos términos.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  8. Cambios a los Términos
                </h3>
                <p className="mb-4">Podemos revisar estos Términos en cualquier momento. El uso continuado constituye su aceptación de los nuevos términos.
                </p>

                <h3 className="text-xl font-semibold mt-6 mb-3">
                  9. Información de Contacto
                </h3>
                <p className="mb-4">Para cualquier pregunta sobre estos Términos de Uso, por favor contáctenos en results@latinocareertest.com.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalPage;